module.exports = __webpack_public_path__ + "img/teacher.be5030ca.webp";